import { render, staticRenderFns } from "./AppStoreIcon.vue?vue&type=template&id=e853c5da"
import script from "./AppStoreIcon.vue?vue&type=script&lang=js"
export * from "./AppStoreIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports